import dynamic from 'next/dynamic';
import { EventProfileProps } from './EventProfile.types';

export const EventProfile = dynamic<{ model: EventProfileProps }>(() =>
  import('./EventProfile').then(mod => mod.EventProfile)
);
